/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ReferentiPage = lazy(() => import('./pages/ReferentiPage'))

export const referentiRoutes: RouteObject[] = [
  {
    path: 'referenti',
    element: <ReferentiPage />,
  },
]
